import swal from "sweetalert2";

const ShowNotification = (message, type) => {
  if (type === "success") swal.fire(type, message, "success");
  else if (type === "info") swal.fire(type, message, "info");
  else swal.fire(type, message, "error");
};

export default ShowNotification;
